import { Icon, Stack, Typography } from '@mui/material';
import { SyncUser, UserType } from '@schooly/api';
import { SchoolInviteStatus } from '@schooly/constants';
import { Attention2Icon, WarningBlock } from '@schooly/style';
import { FC } from 'react';
import { useIntl } from 'react-intl';

export const ParentsWarningNotice: FC<{
  userType: UserType;
  user?: SyncUser & { invite_status?: SchoolInviteStatus };
}> = ({ userType, user }) => {
  const { formatMessage } = useIntl();

  if (!user) return null;

  const getWarningVisibilityStatus = () => {
    switch (userType) {
      case 'adult':
      case 'staff':
      case 'child':
      case 'profile':
        return false;
      case 'parent':
        return user.invite_status === SchoolInviteStatus.Active;
      case 'student':
        return true;

      default: {
        const _: never = userType;
        return _;
      }
    }
  };

  if (!getWarningVisibilityStatus()) return null;

  return (
    <WarningBlock mb={2}>
      <Stack direction="row" gap={2}>
        <Icon sx={{ color: 'background.paper', path: { color: 'common.orange' } }}>
          <Attention2Icon />
        </Icon>
        <Typography variant="h3" color="inherit">
          {formatMessage({ id: 'profile-ParentsWarningNotice' })}
        </Typography>
      </Stack>
    </WarningBlock>
  );
};
